import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppConfig, APP_CONFIG } from './app.config';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

fetch('/assets/config.json')
    .then((response) => response.json())
    .then((config: AppConfig) => {
        if (environment.production) {
            enableProdMode();
        }
        addScripts(config.scripts);

        bootstrapApplication(AppComponent, {
            ...appConfig,
            providers: [
                provideZonelessChangeDetection(), ...appConfig.providers,
                { provide: APP_CONFIG, useValue: config }, provideAnimationsAsync(),
            ]
        }).catch((err) => console.error(err));
    });

function addScripts(scripts: string[]) {
    scripts.forEach((src) => {
        let s = document.createElement('script');
        s.setAttribute('src', src);
        document.head.appendChild(s);
    });
}
